import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Product from '@ltypes/product';

export const productSlice = createSlice({
    name: 'product',
    initialState: null as Product|null,
    reducers: {
        loadProduct: (state, action: PayloadAction<Product>) => {
            let oldState = state === null ? {} : state;
            return {
                ...oldState,
                ...action.payload,
            };
        },

        unloadProduct: (state) => {
            return null;
        },
    }
});

export const { loadProduct, unloadProduct } = productSlice.actions;

export default productSlice.reducer;